export default __webpack_public_path__ + "static/products-bg-base-484f6f55eefdd01a24dea56236966039.png";